export function BrandLogo() {
  return (
    <span className="brand-logo">
      <svg className="brand-mark" viewBox="0 0 104 104" aria-hidden="true" focusable="false">
        <path d="M13 72C30 64 27 47 43 38C56 31 70 32 83 15C77 36 62 41 51 48C37 57 34 77 13 72Z" />
        <path d="M29 88C46 79 45 63 60 55C71 49 83 48 91 35C88 53 77 60 67 66C53 75 47 92 29 88Z" />
      </svg>
      <span className="brand-name">Identifrag</span>
      <span className="brand-beta">Beta</span>
    </span>
  );
}
